import { fetchSupabaseFunction } from "@/lib/shopifySessionToken";
import type { PendingMerchantSetup } from "@/lib/merchantSetup";

export async function registerMerchantAccount(params: {
  email: string;
  password: string;
  merchantSetup: PendingMerchantSetup;
}) {
  const response = await fetchSupabaseFunction("register-merchant-account", {
    body: {
      accountType: "business",
      email: params.email,
      merchantSetup: params.merchantSetup,
      password: params.password,
    },
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || "Failed to register merchant account");
  }

  return payload;
}

export async function verifyMerchantEmail(token: string) {
  const response = await fetchSupabaseFunction("verify-merchant-email", {
    body: { token },
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || "Failed to verify email");
  }

  return payload;
}

export async function resendMerchantVerificationEmail(email: string) {
  const response = await fetchSupabaseFunction("resend-merchant-verification", {
    body: { email },
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || "Failed to resend verification email");
  }

  return payload;
}
